@if (content) {
<div class="fill flex-column height-100 bg-col-w col-b off-canvas-menu">
    <div class="pos-relative flex-column flex-grow overflow-hidden">
        <!-- level 1 -->
        <div class="flex-grow flex-column overflow-y-auto"
             #scroll>
            <div class="m-r pos-relative">
                <!-- search -->
                @if (enabledAc) {
                <advanced-commerce-search-form class="w-10 p-l p-t m-b"
                                               searchId="header"
                                               (focusChange)="onSearchFocusChange($event)"
                                               (closed)="searchClosedHandler($event)"></advanced-commerce-search-form>
                } @else {
                <search class="w-10 p-l p-t m-b"
                        searchId="header"
                        (focusChange)="onSearchFocusChange($event)"
                        (closed)="searchClosedHandler($event)"></search>
                }

                <!-- close -->
                <button class="w-2 right m-t-5 off-canvas-close"
                        type="button"
                        (click)="hideOffCanvas()"
                        aria-label="Close">
                    <i class="icon-close"
                       aria-hidden="true"></i>
                </button>
                <div class="pos-relative">
                    <div class="pos-absolute search-outlet-wrapper pe-none w-12 z-2">
                        <div class="hide-up-container">
                            <div class="ng-hide-animate hide-up hide-up-max pe-auto"
                                 [ngClass]="{'ng-hide': !searchTrayVisible}">
                                @if(enabledAc) {
                                @if(searchTrayVisible) {
                                <advanced-commerce-search-outlet class="w-12 search-outlet scrolling-touch overflow-y-auto bg-col-w"
                                                                 searchId="header"></advanced-commerce-search-outlet>
                                }
                                } @else {
                                <search-outlet class="w-12 search-outlet scrolling-touch overflow-y-auto bg-col-w"
                                               searchId="header"></search-outlet>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- level 1 menu items -->
            <div [ngClass]="{'ng-hide': searchTrayVisible}">
                <ul class="p-l p-r p-b-2">
                    <!-- menu item -->
                    @for (item of content.menu; track $index; let i = $index; let isLast = $last) {
                    <li class="p-t-1">
                        <!-- link / zippy -->
                        <href [link]="item.secondLevelTurnOn && item.secondLevelItems.length ? undefined : item.link"
                              [hrefCurrentClass]="'is-current'">
                            <span class="flex m-b-2 bg-col-41"
                                  [ga4TrackClick]="getNavigationGA4Data(undefined, undefined, item.text)"
                                  [ga4TrackClickOff]="!!(item.secondLevelTurnOn && item.secondLevelItems.length)"
                                  [zippyOpen]="getZippyId(i)"
                                  [zippyOpenOff]="!(client.isCms || (item.secondLevelTurnOn && item.secondLevelItems.length))">
                                <!-- image -->
                                @if (item.image) {
                                <div class="c-4-set m-b-0 ratio-1-1">
                                    <img class="rf"
                                         [image]="item.image">
                                </div>
                                }
                                <!-- text -->
                                <div class="c-8-set m-r-0 flex flex-grow flex-middle flex-justify-between">
                                    <div class="m-t-3 h4"
                                         *iCms="'text' of item"
                                         text></div>
                                    <i class="icon-chevron fs-9 p-t-5 m-r"></i>
                                </div>
                            </span>
                        </href>
                    </li>
                    }
                </ul>
                <!-- Footer links in level 1 -->
                <div class="bg-col-42 m-t-6">
                    <div class="m-l m-t-2">
                        <ng-container *ifNotLoggedIn>
                            <!-- sign in -->
                            <div class="p-t-3 p-b-1">
                                <a class="flex flex-middle"
                                   routerLink="/login">
                                    <i class="icon-account inline-flex m-r-5"
                                       style="font-size: 1.5rem"></i>
                                    <span class="p1">{{'Sign in' | translate}}</span>
                                </a>
                            </div>
                        </ng-container>
                        <ng-container *ifLoggedIn>
                            <!-- my account -->
                            <div class="p-t-3 p-b-1">
                                <a class="flex flex-middle"
                                   routerLink="/account">
                                    <i class="icon-account inline-flex m-r-5"
                                       style="font-size: 1.5rem"></i>
                                    <span class="p1">{{'My account' | translate}}</span>
                                </a>
                            </div>
                        </ng-container>
                        @if (content.footer_links.length) {
                        @for (item of content.footer_links; track $index; let isLast = $last) {
                        <href [link]="item.isMultisite === 'no' ? item.link : undefined">
                            <div class="flex flex-middle p-t-3 p-b-1"
                                 [class.p-b-4]="isLast"
                                 [ga4TrackClick]="getNavigationGA4Data(undefined, undefined, item.text)">
                                @if (item.isMultisite === 'no') {
                                <!-- temp icon -->
                                <div class="inline-block img-width m-r-5">
                                    <div class="w-12 ratio-1-1">
                                        <img [image]="item.icon"
                                             *iCms="'icon' of item"
                                             class="rf">
                                    </div>
                                </div>
                                <div class="p1"
                                     *iCms="'text' of item">
                                </div>
                                }
                                @if (item.isMultisite === 'yes') {
                                <multisite-label class="inline-block"
                                                 [class.pe-none]="hideMultisteRetailSelector"
                                                 [iCmsModalOpen]="multisiteModalId"></multisite-label>
                                }
                            </div>
                        </href>
                        }
                        }
                    </div>
                </div>
            </div>
            <page-footer *ifStandalone
                         class="block w-12 p-b-10"></page-footer>
        </div>
        @for (item of content.menu; track $index; let i = $index) {
        <!-- level 2 -->
        @if (client.isCms || (item.secondLevelTurnOn && item.secondLevelItems.length)) {
        <div [zippy]="getZippyId(i)"
             class="ng-hide ng-hide-animate hide-left pos-absolute bg-col-w fill z-2">
            <div class="fill flex-column overflow-y-auto">
                <div [zippyClose]="uid">
                    <div class="p-t p-l-2 flex flex-middle flex-justify-between"
                         [zippyClose]="getZippyId(i)">
                        <i class="icon-arrow-simple-left fs-9 p-l-2 p-t-1"></i>
                        <span class="h2"
                              *iCms="'text' of item"></span>
                        <!-- close -->
                        <button class="right p-r-5 p-t-2 off-canvas-close"
                                type="button"
                                (click)="hideOffCanvas()"
                                aria-label="Close">
                            <i class="icon-close"
                               aria-hidden="true"></i>
                        </button>
                    </div>
                </div>
                <!-- level 2 - menu items -->
                <div class="p-t-3 wrap">
                    @for (secondLevelItem of item?.secondLevelItems; track $index; let j = $index) {
                    @if (secondLevelItem.title) {
                    <h4 [ngClass]="[secondLevelItem.marginTop || 'm-t', secondLevelItem.titleStyle || 'h4']"
                        class="p-b-2"
                        *iCms="'title' of secondLevelItem"></h4>
                    }
                    @for (listItem of secondLevelItem?.list; track $index; let k = $index; let isLast = $last) {
                    @switch (listItem.listItemVariant) {
                    <!-- text/btn list -->
                    @default {
                    <href [link]="listItem.link">
                        <p [ga4TrackClick]="getNavigationGA4Data(item.text, secondLevelItem.title, listItem.text)"
                           class="m-t-3 m-b-3"
                           [ngClass]="listItem.textItemVariant === 'text' ? (listItem.textStyle || 'p1') : (listItem.ctaStyle || 'button-inline')"
                           *iCms="'text' of listItem"></p>
                    </href>
                    }
                    <!-- colors list -->
                    @case ('colors') {
                    <div [ngClass]="listItem.colorColumns === 'one-col' ? 'c-8-set p-r' : 'c-6-set'"
                         class="m-t-2 m-b-1">
                        <href class="block"
                              [link]="listItem.link">
                            <div [ga4TrackClick]="getNavigationGA4Data(item.text, secondLevelItem.title, listItem.text)"
                                 class="flex flex-middle bg-col-41">
                                <div class="ratio-1-1 m-r-3 b-col-42 color-width"
                                     [class.b-a]="listItem.color === 'rgba(255, 255, 255, 1)'">
                                    @if (listItem.color) {
                                    <div class="fill"
                                         [ngStyle]="{'background-color': listItem.color || 'rgb(255, 255, 255)'}">
                                    </div>
                                    }
                                    @if (listItem.isNewColor) {
                                    <p class="pos-absolute top-50 left-50 c1 center italic"
                                       [ngStyle]="{'color': listItem.newTextColor || 'rgb(255, 255, 255)'}"
                                       style="transform: translate(-50%, -50%);">{{'New' | translate}}</p>
                                    }
                                </div>
                                <p [ngClass]="[listItem.textStyle || 'p1', listItem.colorColumns === 'two-cols' ? 'color-text-width' : '']"
                                   *iCms="'text' of listItem"></p>
                            </div>
                        </href>
                    </div>
                    }
                    <!-- products list -->
                    @case ('products') {
                    <div class="m-t-3">
                        @for (productId of listItem.products; track $index) {
                        <div class="c-6-set">
                            <product [modelId]="productId"
                                     [ga4MenuNavigation]="getNavigationGA4Data(item.text, secondLevelItem.title)">
                            </product>
                        </div>
                        }
                    </div>
                    }
                    <!-- images list -->
                    @case ('images-list') {
                    <href [link]="listItem.link"
                          class="block">
                        <div [ga4TrackClick]="getNavigationGA4Data(item.text, secondLevelItem.title, listItem.text)"
                             class="flex flex-middle m-b-2 bg-col-41">
                            <div class="c-6-set m-b-0 ratio-3-4">
                                @if (listItem.image) {
                                <div class="rf z-1">
                                    <img class="rf"
                                         [image]="listItem.image">
                                </div>
                                }
                            </div>
                            <div class="c-6-set">
                                <div class="m-l-1">
                                    <h4 [ngClass]="listItem.textStyle || 'h4'"
                                        *iCms="'text' of listItem"></h4>
                                    <button [ngClass]="listItem.ctaStyle || 'button-inline'"
                                            *iCms="'imageCta' of listItem"></button>
                                </div>
                            </div>
                        </div>
                    </href>
                    }
                    <!-- submenu list -->
                    @case ('submenu') {
                    <span class="va-m"
                          [ngClass]="secondLevelItem?.list?.length === 1 ? 'w-12' : (secondLevelItem?.list?.length === 2 ? 'w-6 m-r--1 m-l--1' : ( k===0 ? 'w-3' : (k===1 ? 'w-5 m-r--1 m-l--1' : 'w-4')))"
                          [class.right]="secondLevelItem?.list?.length === 2 && k===1 || secondLevelItem?.list?.length === 3 && k===2"
                          [class.center]="secondLevelItem?.list?.length === 1 || secondLevelItem?.list?.length === 3  && k===1 "
                          [class.left]="k===0 && (secondLevelItem?.list?.length === 2 || secondLevelItem?.list?.length === 3)"
                          [zippyOpen]="'tab.' + k">
                        <span class="m-t-2 m-b-2 b-col-b"
                              [ngClass]="listItem.textStyle || 'h4'"
                              zippyClass="b-b !b-b-w-0 !col-12"
                              [zippyName]="'tab.' + k"
                              *iCms="'text' of listItem"></span></span>
                    @if (!isLast && (secondLevelItem?.list?.length || 0) >1) {
                    <span>|</span>
                    }
                    }
                    <!-- submenu content -> below accordion list! -->
                    <!-- accordion list -->
                    @case ('accordions') {
                    <div>
                        <expandable [ngClass]="listItem.textStyle || 'h4'"
                                    [expandableTitle]="listItem?.text"
                                    [expandableIcon]="'plus'">
                            <div class="p-t-7">
                                @for (thirdListItem of listItem?.thirdLevelItems; track $index; let l = $index;
                                let isLast = $last) {
                                @switch (thirdListItem.variant) {
                                @default {
                                <href class="block"
                                      [link]="thirdListItem.textLink">
                                    <div [ga4TrackClick]="getNavigationGA4Data(item.text, listItem.text, thirdListItem.text || thirdListItem.textLink)"
                                         class="m-t-2 m-b-2 flex flex-middle">
                                        @if (thirdListItem.icon) {
                                        <div class="ratio-1-1 icon-width">
                                            <img class="rf"
                                                 [image]="thirdListItem.icon">
                                        </div>
                                        }
                                        <span [ngClass]="[thirdListItem.textStyle || 'p1', thirdListItem.icon ? 'm-l-2' : '']"
                                              class="col-1"
                                              *iCms="'text' of thirdListItem"></span>
                                    </div>
                                </href>
                                }
                                @case ('colors') {
                                <div [ngClass]="thirdListItem.colorColumns === 'one-col' ? 'c-8-set p-r' : 'c-6-set'"
                                     class="m-t-2 m-b-1">
                                    <href class="block"
                                          [link]="thirdListItem.textLink">
                                        <div [ga4TrackClick]="getNavigationGA4Data(item.text, listItem.text, thirdListItem.text || thirdListItem.textLink)"
                                             class="flex flex-middle bg-col-41">
                                            <div class="ratio-1-1 m-r-3 b-col-42 color-width"
                                                 [class.b-a]="thirdListItem.color === 'rgba(255, 255, 255, 1)'">
                                                @if (thirdListItem.color) {
                                                <div class="fill"
                                                     [ngStyle]="{'background-color': thirdListItem.color || 'rgb(255, 255, 255)'}">
                                                </div>
                                                }
                                                @if (thirdListItem.isNewColor) {
                                                <p class="pos-absolute top-50 left-50 c1 center italic"
                                                   [ngStyle]="{'color': thirdListItem.newTextColor || 'rgb(255, 255, 255)'}"
                                                   style="transform: translate(-50%, -50%);">
                                                    {{'New' | translate}}</p>
                                                }
                                            </div>
                                            <p [ngClass]="[thirdListItem.textStyle || 'p1', thirdListItem.colorColumns === 'two-cols' ? 'color-text-width' : '']"
                                               *iCms="'text' of thirdListItem"></p>
                                        </div>
                                    </href>
                                </div>
                                }
                                }
                                }
                            </div>
                        </expandable>
                    </div>
                    }
                    }
                    }
                    <!-- submenu content -->
                    @for (listItem of secondLevelItem?.list; track $index; let k = $index; let isLast = $last) {
                    <div [zippy]="'tab.' +  k"
                         [zippyState]="!k"
                         [zippyAuto]="k === 0">
                        @switch (listItem.listItemVariant) {
                        @case ('submenu') {
                        <div class="left-0 m-t-5 w-12">
                            @for (thirdListItem of listItem?.thirdLevelItems; track $index; let l = $index; let
                            isLast = $last) {
                            @switch (thirdListItem.variant) {
                            @default {
                            <href [link]="thirdListItem.textLink">

                                <div [ga4TrackClick]="getNavigationGA4Data(item.text, listItem.text, thirdListItem.text || thirdListItem.textLink)"
                                     class="m-t m-b flex flex-middle">
                                    @if (thirdListItem.icon) {
                                    <div class="ratio-1-1 icon-width">
                                        <img class="rf"
                                             [image]="thirdListItem.icon">
                                    </div>
                                    }
                                    <span class="m-t-2 m-b-2"
                                          [ngClass]="[thirdListItem.textStyle || 'p1', thirdListItem.icon ? 'm-l-2' : '']"
                                          *iCms="'text' of thirdListItem"></span>
                                </div>
                            </href>
                            }
                            @case ('colors') {
                            <div [ngClass]="thirdListItem.colorColumns === 'one-col' ? 'c-8-set p-r' : 'c-6-set'"
                                 class="m-t-2 m-b-1">
                                <href class="block"
                                      [link]="thirdListItem.textLink">
                                    <div [ga4TrackClick]="getNavigationGA4Data(item.text, listItem.text, thirdListItem.text || thirdListItem.textLink)"
                                         class="flex flex-middle bg-col-41">
                                        <div class="ratio-1-1 m-r-3 b-col-42 color-width"
                                             [class.b-a]="thirdListItem.color === 'rgba(255, 255, 255, 1)'">
                                            @if (thirdListItem.color) {
                                            <div class="fill"
                                                 [ngStyle]="{'background-color': thirdListItem.color || 'rgb(255, 255, 255)'}">
                                            </div>
                                            }
                                            @if (thirdListItem.isNewColor) {
                                            <p class="pos-absolute top-50 left-50 c1 center italic"
                                               [ngStyle]="{'color': thirdListItem.newTextColor || 'rgb(255, 255, 255)'}"
                                               style="transform: translate(-50%, -50%);">{{'' |
                                                translate}}New</p>
                                            }
                                        </div>
                                        <p [ngClass]="[thirdListItem.textStyle || 'p1', thirdListItem.colorColumns === 'two-cols' ? 'color-text-width' : '']"
                                           *iCms="'text' of thirdListItem"></p>
                                    </div>
                                </href>
                            </div>
                            }
                            }
                            }
                        </div>
                        }
                        }
                    </div>
                    }
                    }
                </div>
                <!-- image -->
                @for (imageItem of item?.imageSection; track $index; let j = $index) {
                <href [link]="imageItem.imageLink">
                    <div [ga4TrackClick]="getNavigationGA4Data(item.text, undefined, imageItem.imageTitle || imageItem.imageLink)"
                         [ngClass]="imageItem.marginTop || 'm-t-0'"
                         class="wrap m-b">
                        <div [ngClass]="imageItem.imageRatio || 'ratio-1-1'"
                             class="overflow-hidden">
                            <shell></shell>
                            @if (imageItem.image) {
                            <div class="rf z-1">
                                <img class="rf"
                                     [image]="imageItem.image">
                                <!-- overlap text -->
                                @if (imageItem.imageTextVariant === 'overlap') {
                                <div class="pos-absolute bottom-0 p-a w-12"
                                     [ngStyle]="{'background-color' : (imageItem.imageTextBackgroundColor || 'rgb(255, 255, 255)'), 'color' : (imageItem.imageTextColor || 'rgb(0, 0, 0)')}">
                                    <p [ngClass]="imageItem.imageSubtitleStyle || 'p1'"
                                       *iCms="'imageSubtitle' of imageItem"></p>
                                    <h3 [ngClass]="imageItem.imageTitleStyle || 'h3'"
                                        class="p-t-2"
                                        *iCms="'imageTitle' of imageItem"></h3>
                                </div>
                                }
                            </div>
                            }
                        </div>
                        <!-- text below -->
                        @if (imageItem.imageTextVariant === 'below') {
                        <div class="p-a"
                             [ngClass]="imageItem.imageTextBackgroundColor">
                            <p [ngClass]="imageItem.imageSubtitleStyle || 'p1'"
                               *iCms="'imageSubtitle' of imageItem"></p>
                            <h3 [ngClass]="imageItem.imageTitleStyle || 'h3'"
                                cmsTextField="imageTitle"
                                *iCms="'imageTitle' of imageItem"></h3>
                        </div>
                        }
                    </div>
                </href>
                }
            </div>
        </div>
        }
        }
    </div>
</div>
}